export default __webpack_public_path__ + "static/media/cert.bd0f2742.svg";